import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../message";
import CampaignsService from "../../../services/campagins";

export const getCampaign = createAsyncThunk(
  "campaigns/getCampaign",
  async (id, thunkAPI) => {
    try {
      const result = await CampaignsService.getCampaign(id);
      console.log('getCampaign ######- ', result)
      if (result?.data) {
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result.data.message));
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getVenderResponseByCampaignUuid = createAsyncThunk(
  "campaigns/getCampaignLogs/vender-res",
  async (payload, thunkAPI) => {
    try {
      const response = await CampaignsService.getCampaignLogsDetailsByUuid(payload);
      console.log("API Response:", response);

      return response?.success ? { payload: response?.data, log: response?.log } : [];
    } catch (error) {
      console.error("Error in getCampaignJourneyLogsDetails:", error);
      thunkAPI.dispatch(
        setMessage(error.message || "Error fetching campaign journey logs")
      );
      return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
);

export const saveCampaignSettingThunkApi = createAsyncThunk(
  'campaign/saveCampaignSetting',
  async (payload, thunkAPI) => {
    try {
      const response = await CampaignsService.saveCampaignSetting(payload);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response?.message || "Something Went Wrong. Please Try Again");
      } else {
        return response.message || "Setting Successfully Updated.";
      }
    } catch (error) {
      console.error("Error in saveCampaignSettingThunkApi:", error);
      return thunkAPI.rejectWithValue(error?.message || "Something went wrong.");
    }
  }
)


export const getCampaignSuggestions = createAsyncThunk(
  "campaigns/getCampaignLogs/suggestions",
  async (body, thunkAPI) => {
    try {
      const response = await CampaignsService.getCampaignSuggestions(body);
      return response.campaigns ? response.campaigns : [];
    } catch (error) {
      console.error("Error in getCampaignJourneyLogsDetails:", error);
      thunkAPI.dispatch(
        setMessage(error.message || "Error fetching campaign journey logs")
      );
      return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
);

// getSnsStatesSummary
export const getSnsStatesSummary = createAsyncThunk(
  "campaigns/getCampaignLogs/getSnsStatesSummary",
  async (body, thunkAPI) => {
    try {
      const response = await CampaignsService.getSnsStatesSummary(body);

      console.log("stats : ", response);
      if (response?.success) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error in getSnsStatesSummary:", error);
      thunkAPI.dispatch(
        setMessage(error.message || "Error fetching campaign journey logs")
      );
      return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
);


// getSnsStatsByVendor — per-vendor delivery breakdown
export const getSnsStatsByVendor = createAsyncThunk(
  "campaigns/getCampaignLogs/getSnsStatsByVendor",
  async (body, thunkAPI) => {
    try {
      const response = await CampaignsService.getSnsStatsByVendor(body);
      if (response?.success) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error in getSnsStatsByVendor:", error);
      return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
);


export const getCampStatesSummary = createAsyncThunk(
  "campaigns/getCampaignLogs/getCampaignStatesSummary",
  async (body, thunkAPI) => {
    try {
      const response = await CampaignsService.getCampaignStatsByUuid(body);

      console.log("stats : ", response);
      if (response?.success) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error in getSnsStatesSummary:", error);
      thunkAPI.dispatch(
        setMessage(error.message || "Error fetching campaign journey logs")
      );
      return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
);


const initialState = {
  campaign: {}, venderLogs: null, camapignMoreInfo: null,
};

const campaignSlice = createSlice({
  name: "campaign",
  initialState,

  extraReducers: {
    [getCampaign.fulfilled]: (state, action) => {
      state.campaign = action.payload;
    },
    [getCampaign.rejected]: (state, action) => {
      state.campaign = null;
    },
    [getVenderResponseByCampaignUuid.fulfilled]: (state, action) => {
      state.venderLogs = action.payload?.payload || [];
    },
    [getVenderResponseByCampaignUuid.rejected]: (state, action) => {
      state.venderLogs = null;
    },

    [getSnsStatesSummary.fulfilled]: (state, action) => {
      state.snsStatSummary = action.payload;
    },
    [getSnsStatsByVendor.fulfilled]: (state, action) => {
      state.snsVendorBreakdown = action.payload;
    },
    [getSnsStatsByVendor.rejected]: (state) => {
      state.snsVendorBreakdown = null;
    },

    [getSnsStatesSummary.rejected]: (state, action) => {
      state.snsStatSummary = null;
    },
    [getCampStatesSummary.fulfilled]: (state, action) => {
      state.camapignMoreInfo = action.payload;
    },
    [getCampStatesSummary.rejected]: (state, action) => {
      state.camapignMoreInfo = null;
    },
  }
});

export default campaignSlice.reducer;
